module.exports = __webpack_public_path__ + "static/media/AboutMeImage37.e88a7632.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AboutMeImage37.png
// module id = 76
// module chunks = 0